/**
 * Warehouse kind helpers for the "All / Standard / Mobile warehouse" filter.
 * A mobile warehouse is a vehicle stock (`type === 'vehicle'`).
 */

/**
 * @param {object} w Warehouse row.
 * @returns {boolean} True for a mobile (vehicle) warehouse.
 */
export const isMobileWarehouse = (w) => w?.type === 'vehicle';

/**
 * Narrow a warehouse list by kind without mutating it.
 *
 * @param {Array<object>} list Warehouse rows.
 * @param {'all'|'standard'|'vehicle'} [kind='all'] Kind to keep.
 * @returns {Array<object>} Filtered copy ([] for a non-array).
 */
export const filterWarehousesByKind = (list, kind = 'all') => {
    if (!Array.isArray(list)) {
        return [];
    }

    if (kind !== 'standard' && kind !== 'vehicle') {
        return list.slice();
    }

    return list.filter((w) => isMobileWarehouse(w) === (kind === 'vehicle'));
};

/**
 * @param {Array<object>} list Warehouse rows.
 * @returns {boolean} True when the list holds both standard and mobile warehouses.
 */
export const hasMixedWarehouseKinds = (list) => Array.isArray(list)
    && list.some(isMobileWarehouse)
    && list.some((w) => !isMobileWarehouse(w));
